// Modal "Câmbio do Orçamento": o que o usuário digita/escolhe vai direto para `dados` (a tela
// recalcula ao vivo). Cancelar/fechar sem "Salvar Câmbio" tem de devolver a moeda e o câmbio de
// antes de abrir o modal (item 12: #550 ficava com o câmbio digitado na barra TOTAL ACCESS).
export function capturarCambioOrcamento(dados = {}) {
    return { moeda: dados.moeda, cambio: dados.cambio };
}

export function restaurarCambioOrcamento(dados = {}, capturado = null) {
    if (!capturado) return dados;
    if (dados.moeda === capturado.moeda && dados.cambio === capturado.cambio) return dados;
    return { ...dados, moeda: capturado.moeda, cambio: capturado.cambio };
}
